"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
function _templateObject() {
    var data = _taggedTemplateLiteralLoose(["\n  h3 {\n    max-width: 600px;\n  }\n\n  .roles {\n    margin-top: var(--gutter-small-2);\n    font-size: 1.8rem;\n  }\n\n  li {\n      position: relative;\n      list-style: none;\n      padding-left: 2rem;\n\n      &::before {\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        content: \"\";\n        display: inline-block;\n        height: .8rem;\n        width: .8rem;\n        background: var(--black-0);\n        border-radius: 50%;\n      }\n  }\n"]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} strings.raw = raw; return strings; }
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const CompanyAndTags_1 = __importDefault(require("../CompanyAndTags"));
var StyledWork = styled_1.default.div(_templateObject());
var Work = function Work(_ref) {
    var from = _ref.from, to = _ref.to, title = _ref.title, notes = _ref.notes, tags = _ref.tags, organisation = _ref.organisation;
    return /*#__PURE__*/ react_1.default.createElement(StyledWork, {
        className: "card card--off-white"
    }, /*#__PURE__*/ react_1.default.createElement("p", null, new Date(from).getFullYear(), to ? " - " + new Date(to).getFullYear() : to !== undefined && ' - now'), /*#__PURE__*/ react_1.default.createElement("h3", null, title), /*#__PURE__*/ react_1.default.createElement(CompanyAndTags_1.default, {
        organisation: organisation,
        tags: tags
    }), /*#__PURE__*/ react_1.default.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: notes
        }
    }));
};
exports.default = Work;
